import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TiimeInputContainerModule, TiimeSelectModule, TiimeOptionModule } from 'tiime-material';

import { SelectBase } from '@bases/selector/select.base';
import { AuditEntityType } from '@enums/audit-entity-type.enum';
import { ContractStatus } from '@gi/enums/contract-status.enum';
import { BusinessUser } from '@models/business-user';
import { StatusType } from '@modules/core/types/status-type.type';
import { HistoryInfosButtonComponent } from '@shared-components/history-infos-button/history-infos-button.component';
import { StatusComponent } from '@shared-components/status/status.component';
import { AtByPipe } from '@shared-pipes/at-by/at-by.pipe';
import { DisableContractStatusPipe } from '@shared-pipes/disable-contract-status/disable-contract-status.pipe';
import { StatusColorPipe } from '@shared-pipes/status-color/status-color.pipe';
import { StatusLabelPipe } from '@shared-pipes/status-label/status-label.pipe';

@Component({
  selector: 'app-contract-status-select',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    TiimeOptionModule,
    StatusLabelPipe,
    StatusComponent,
    StatusColorPipe,
    DisableContractStatusPipe,
    HistoryInfosButtonComponent,
    AtByPipe
  ],
  templateUrl: './contract-status-select.component.html',
  styleUrls: ['./contract-status-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractStatusSelectComponent extends SelectBase<ContractStatus> {
  @Input({ required: true }) contractStatus: ContractStatus;
  @Input() contractStatusAt: Date;
  @Input() contractStatusBy: BusinessUser;
  @Input() label = 'État';
  @Input() contractId: number;
  @Input('statusDisabled') set setStatusDisabled(statusDisabled: boolean) {
    this.setDisabled(statusDisabled);
  }

  readonly statusType: StatusType = 'contract';
  readonly historyEntityType = AuditEntityType.contracts;
  readonly historyEntityTitle = 'État contrat';

  constructor() {
    super();
    this.selectorData = Object.values(ContractStatus);
  }
}
